module.exports = __webpack_public_path__ + "perl.516ba9.svg";